import React from "react";
import { motion } from "framer-motion";
import { ArrowRight } from "lucide-react";
import { useNavigate } from "react-router-dom";

export default function CTA() {
  const navigate = useNavigate();
  return (
    <section
      data-testid="cta-section"
      className="relative py-24 md:py-40 overflow-hidden isolate"
    >
      <div className="absolute inset-0 z-0">
        <div className="absolute inset-0 grid-bg opacity-60" />
        <div className="absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 w-[800px] h-[800px] rounded-full bg-[#1F5EFF]/12 blur-[140px]" />
      </div>
      <div className="max-w-6xl mx-auto px-6 md:px-10 text-center relative z-10">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.9 }}
        >
          <div className="font-mono-alt text-[12px] text-[#1F5EFF] mb-6">
            · Ready When You Are ·
          </div>
          <h2 className="font-display text-5xl md:text-7xl lg:text-8xl font-light tracking-tighter text-white leading-[0.95]">
            Ready to Protect
            <br />
            <span className="text-white/50">Your Vehicle?</span>
          </h2>
          <p className="mt-8 text-white/60 text-base md:text-lg max-w-xl mx-auto">
            Pick your service, see the exact price and lock in your slot.
            Transparent pricing.
          </p>
          <div className="mt-12 flex flex-col sm:flex-row items-center justify-center gap-4">
            <button
              data-testid="cta-book-btn"
              onClick={() => navigate("/book")}
              className="group inline-flex items-center gap-3 px-8 py-4 rounded-full bg-[#1F5EFF] text-white font-semibold hover:bg-white hover:text-black transition-all duration-300 blue-glow"
            >
              Book Now
              <ArrowRight className="w-4 h-4 transition-transform group-hover:translate-x-1" />
            </button>
            <a
              href="tel:+13683808483"
              data-testid="cta-call-btn"
              className="inline-flex items-center gap-3 px-8 py-4 rounded-full border border-white/25 text-white hover:border-white hover:bg-white/5 transition-all"
            >
              +1 (368) 380-8483
            </a>
          </div>
        </motion.div>
      </div>
    </section>
  );
}
